"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLegacyValues = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _reactNative = require("react-native");
var _OptionalExpoApplication = require("./optional/OptionalExpoApplication");
var _OptionalExpoFileSystem = require("./optional/OptionalExpoFileSystem");
var getLegacyValues = function () {
  var _ref = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee() {
    var posthogFileDirectory, posthogDistinctIdFile, posthogAnonymousIdFile, res;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!_OptionalExpoFileSystem.OptionalExpoFileSystem || !_OptionalExpoApplication.OptionalExpoApplication)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            if (!(_reactNative.Platform.OS === 'ios')) {
              _context.next = 30;
              break;
            }
            posthogFileDirectory = "".concat(_OptionalExpoFileSystem.OptionalExpoFileSystem.documentDirectory, "../Library/Application%20Support/").concat(_OptionalExpoApplication.OptionalExpoApplication.applicationId, "/");
            posthogDistinctIdFile = posthogFileDirectory + 'posthog.distinctId';
            posthogAnonymousIdFile = posthogFileDirectory + 'posthog.anonymousId';
            res = {
              distinctId: undefined,
              anonymousId: undefined
            };
            _context.prev = 7;
            _context.t0 = JSON;
            _context.next = 11;
            return _OptionalExpoFileSystem.OptionalExpoFileSystem.readAsStringAsync(posthogDistinctIdFile);
          case 11:
            _context.t1 = _context.sent;
            res.distinctId = _context.t0.parse.call(_context.t0, _context.t1)['posthog.distinctId'];
            _context.next = 17;
            break;
          case 15:
            _context.prev = 15;
            _context.t2 = _context["catch"](7);
          case 17:
            _context.prev = 17;
            _context.t3 = JSON;
            _context.next = 21;
            return _OptionalExpoFileSystem.OptionalExpoFileSystem.readAsStringAsync(posthogAnonymousIdFile);
          case 21:
            _context.t4 = _context.sent;
            res.anonymousId = _context.t3.parse.call(_context.t3, _context.t4)['posthog.anonymousId'];
            _context.next = 27;
            break;
          case 25:
            _context.prev = 25;
            _context.t5 = _context["catch"](17);
          case 27:
            return _context.abrupt("return", res);
          case 30:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[7, 15], [17, 25]]);
  }));
  return function getLegacyValues() {
    return _ref.apply(this, arguments);
  };
}();
exports.getLegacyValues = getLegacyValues;